import { memo, useEffect, useState } from "react";
import SearchComponent from "./Serach";
import {
  IconButton,
  Tooltip,
} from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import { MessageTypeConstants } from "../../../services/bot/Message";
import { handleCalendarToolBarChange } from "../../../state/actions/tabStack";
import { processSendMessage } from "../../../services/bot/conversation/SendMessage";
import { ActionBtn } from "./styled";
import { ImagePath } from "../../../assets/ImagePath";
import { getLabelForView, getLocalTimezone } from "../../../utils/moment";

import RefreshIcon from "@mui/icons-material/Refresh";
import momentTz from "moment-timezone";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import CalendarTools from "./CalendarTools";
import FMFilter from "../../tabs/FMFilter/index";
import moment from "moment/moment";
import { setBotWaitLoaderWithShimmer } from "../../../state/actions/loader";

dayjs.extend(utc);
dayjs.extend(timezone);


const CustomToolbar = ({
  options,
  parentDocId,
  parentTabId,
  messageType,
  onView,
  conversation,
  onNavigate,
  handleSelectAllRows,
  handleAction = () => { },
  doTimeBaseSearchCallback = () => { },
}) => {

  const bgState = useSelector((state) => state.tabStack?.bgClndrToolBarState);
  const [shouldShowClrIcon, setShouldShowClrIcon] = useState(false);
  const dispatch = useDispatch();
  const isOnline = useSelector((state) => state.user.isOnline);

  const [currView, setCurrView] = useState(bgState?.view || options.view || "month");
  const [searchValue, setSearchValue] = useState(options?.activeQueryString || "");
  const tabId = options?.parent?.length || options.sectionId ? parentTabId : options.tabId;

  const localTZ = getLocalTimezone();
  const selectedDateInitial = options.startDate
    ? momentTz(options.startDate).tz(localTZ)
    : momentTz().tz(localTZ);

  const [selectedDate, setSelectedDate] = useState(selectedDateInitial);

  useEffect(() => {
    if (options?.startDate) {
      let view = options?.view || "";
      let normalizedDate = moment(options?.startDate); // convert to moment

      if (view === "week")
        normalizedDate = normalizedDate.startOf("week");
      else if (view === "day")
        normalizedDate = normalizedDate.startOf("day");
      else if (view === "month")
        normalizedDate = normalizedDate.startOf("month");

      setSelectedDate(normalizedDate);

      const lbl = getLabelForView(normalizedDate, view);
      dispatch(handleCalendarToolBarChange({ view, label: lbl }));
    }
  }, [options])

  const handleRefreshIconClick = () => {
    if (options.style !== "map") {
      setSearchValue("");
    }
    handleAction("onRefresh", null, null, null, null, true);
    setShouldShowClrIcon(false);
  };

  const handleDownloadIconClick = () => {
    handleAction("onDownload", null, null, null, null, true);
  };


  // UPDATE DATE & DO SEARCH
  const handleSelectedDate = (date, view) => {
    let unixMs;

    switch (view) {
      case "day":
        unixMs = date.startOf("day").valueOf();
        break;

      case "week":
        unixMs = date.clone().startOf("week").valueOf();
        break;

      case "month":
        unixMs = date.clone().startOf("month").valueOf();
        break;

      default:
        unixMs = date.valueOf();
    }

    const scaleView = view === "day" ? 2 : view === "week" ? 1 : 0;

    // if (doTimeBaseSearchCallback) {
    //   doTimeBaseSearchCallback(unixMs, scaleView);
    // } else {
    processSendMessage({
      messageType: MessageTypeConstants.MESSAGE_TYPE_TABLE_RESPONSE,
      message: {
        controlId: options.controlId,
        tabId: tabId,
        sectionId: options.sectionId,
        parentDocId,
        action: "search",
        date: unixMs,
        timeScaleView: scaleView,
        tz: localTZ,
      },
    });
    // }
  };

  // NAVIGATION: NEXT / PREV / TODAY
  const onNavigateTable = (action) => {
    dispatch(setBotWaitLoaderWithShimmer(true))
    let newDate = selectedDate.clone();

    if (action === "NEXT") newDate.add(1, currView);
    if (action === "PREV") newDate.subtract(1, currView);
    if (action === "TODAY") newDate = momentTz().tz(localTZ);

    setSelectedDate(newDate);
    handleSelectedDate(newDate, currView);

    const lbl = getLabelForView(newDate, currView);
    dispatch(handleCalendarToolBarChange({ label: lbl }));
  };


  // VIEW CHANGE
  const onViewChangeTable = (view) => {
    if (!selectedDate) return;

    if (onView) {
      onView(view);
    } else {

      setCurrView(view);

      let normalizedDate = selectedDate.clone();
      if (view === "week") normalizedDate = normalizedDate.startOf("week");
      else if (view === "day") normalizedDate = normalizedDate.startOf("day");
      else if (view === "month") normalizedDate = normalizedDate.startOf("month");

      setSelectedDate(normalizedDate);

      const lbl = getLabelForView(normalizedDate, view);
      handleSelectedDate(normalizedDate, view);

      dispatch(handleCalendarToolBarChange({ view, label: lbl }));
    }
  };


  return (
    <div className="">
      <div className="flex md:flex-row flex-row md:gap-0 gap-2 items-center justify-between px-3 py-2">
        <div className="flex items-center gap-2">
          <CalendarTools
            firstTools={true}
            label={bgState?.label || ""}
            currView={currView}
            messageType={messageType}
            onNavigate={onNavigate}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            handleSelectedDate={handleSelectedDate}
            onNavigateTable={onNavigateTable}
          />
        </div>

        <div className="flex items-center gap-5">
          {options.allowSearch && (
            <SearchComponent
              options={options}
              parentDocId={parentDocId}
              parentTabId={parentTabId}
              isOnline={isOnline}
              searchValue={searchValue}
              setSearchValue={setSearchValue}
              setShouldShowClrIcon={setShouldShowClrIcon}
              shouldShowClrIcon={shouldShowClrIcon}
              handleAction={handleAction}
            />
          )}

          {options.filterActive && (
            <div>
              <FMFilter
                options={options}
                conversation={conversation}
                parentTabId={parentTabId}
              />
            </div>
          )}
          <CalendarTools
            secondTools={true}
            view={currView}
            views={bgState?.views || []}
            messageType={messageType}
            handleChange={(e) => onViewChangeTable(e.target.value)}
          />
          {options?.allowDownload && (
            <div className="border-l border-l-purple-100 border-r border-r-purple-100 px-3 py-2" >
              <Tooltip title="Download">
                <div
                  className="search-icon-button unset-design"

                  onClick={() => handleDownloadIconClick()}
                  size="large"
                >
                  <img
                    src={ImagePath.downloadbn}
                    alt="download"
                    className="cursor-pointer w-4 h-4"
                  />
                </div>
              </Tooltip>
            </div>
          )}

          {options?.allowRefresh && (
            <div>
              <Tooltip title="Refresh">
                <IconButton
                  className="search-icon-button"
                  disabled={!isOnline}
                  onClick={() => handleRefreshIconClick()}
                  size="large"
                >
                  <RefreshIcon
                    color="#000"
                    className="text-black"
                  />
                </IconButton>
              </Tooltip>
            </div>
          )}

          {messageType === MessageTypeConstants.MESSAGE_TYPE_TABLE && (
            <>
              {!options?.topTableMenu && options?.confirmAction && (
                <ActionBtn
                  variant="contained"
                  onClick={() => handleAction("onConfirm")}
                >
                  {options?.confirmAction}
                </ActionBtn>
              )}
              {/* {options?.topTableMenu && (
                // <CustomizedMenu
                //   dropdownOptions={options?.topTableMenu}
                // // handleMenuItemClick={handleMenuItemClickWrapper(
                // //     'topMenu',
                // //     undefined,
                // //     undefined,
                // //     selectedRow,
                // //     'selectedOption',
                // // )} 
                // />
              )} */}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default memo(CustomToolbar);
